import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import { openDialog } from '../base/dialog/actions';
import { SIGNATURE_ACTIVE, SET_SIGNATURE_CONTROLLER, SET_RECEIVER_SIGNATURE_ENABLED, SET_RECEIVER_SIGNATURE_TRANSPORT, SET_REQUESTED_SIGNATURE_PARTICIPANT } from './actionTypes';
//@ts-ignore
import SignatureDialog from './components/SignatureDialog';
import { EVENTS, PERMISSIONS_ACTIONS, SIGNATURE_MESSAGE_NAME, } from './constants';
import { sendSignatureEndpointMessage } from './functions';
import logger from './logger';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
import { showNotification } from '../notifications/actions';
import { PARTICIPANT_UPDATED } from '../base/participants/actionTypes';
let receiverEndpointMessageListener;
export function openSignatureAuthorizationDialog(participantId) {
    return openDialog(SignatureDialog, { participantId });
}
export function setSiganatureActive(active) {
    return (dispatch, getState) => {
        const state = getState();
        const { active: oldActive } = state['features/signature'];
        const { conference } = state['features/base/conference'];
        if (active !== oldActive) {
            dispatch({
                type: SIGNATURE_ACTIVE,
                active
            });
            conference?.setLocalParticipantProperty('signatureSessionStatus', active);
        }
    };
}
export function sendrequestSignature(userId) {
    return (dispatch, getState) => {
        const state = getState();
        logger.log(`Requsting signature permissions from: ${userId}`);
        dispatch({
            type: PARTICIPANT_UPDATED,
            participant: {
                userId,
                supportsSignature: true
            }
        });
        const { conference } = state['features/base/conference'];
        dispatch({
            type: SET_REQUESTED_SIGNATURE_PARTICIPANT,
            requestedParticipant: userId
        });
        if (!sendSignatureEndpointMessage(conference, userId, {
            type: EVENTS.permissions,
            action: PERMISSIONS_ACTIONS.request
        })) {
        }
    };
}
export function endpointMessageReceived(participantId, message) {
    return (dispatch, getState) => {
        const { action, name, type } = message;
        if (name !== SIGNATURE_MESSAGE_NAME) {
            return;
        }
        dispatch(openSignatureAuthorizationDialog(participantId));
        dispatch(Close());
    };
}
export function enableReceiver() {
    return (dispatch, getState) => {
        const state = getState();
        const { enabled } = state['features/signature'].receiver;
        if (enabled) {
            return;
        }
        const { connection } = state['features/base/connection'];
        const { conference } = state['features/base/conference'];
        if (!connection || !conference) {
            return;
        }
        dispatch({
            type: SET_RECEIVER_SIGNATURE_ENABLED,
            enabled: true
        });
        connection.addFeature('/signature', true);
        receiverEndpointMessageListener = (participant, message) => {
            dispatch(endpointMessageReceived(participant.getId(), message));
        };
        conference.on(JitsiConferenceEvents.ENDPOINT_MESSAGE_RECEIVED, receiverEndpointMessageListener);
    };
}
export function setReceiverTransport(transport) {
    return {
        type: SET_RECEIVER_SIGNATURE_TRANSPORT,
        transport
    };
}
export function Close() {
    return (dispatch, getState) => {
        const state = getState();
        const { enabled } = state['features/signature'];
        if (!enabled) {
            return;
        }
        const { connection } = state['features/base/connection'];
        const { conference } = state['features/base/conference'];
        if (!connection || !conference) {
            return;
        }
        logger.log('Remote control receiver disabled.');
        dispatch({
            type: SET_RECEIVER_SIGNATURE_ENABLED,
            enabled: false
        });
        dispatch(stopSigantureReceiver(true));
        connection.removeFeature('/signature');
        conference.off(JitsiConferenceEvents.ENDPOINT_MESSAGE_RECEIVED, receiverEndpointMessageListener);
    };
}
export function stopSigantureReceiver(dontNotifyLocalParty = false, dontNotifyRemoteParty = false) {
    return (dispatch, getState) => {
        const state = getState();
        const { receiver } = state['features/signature'];
        const { controller, transport } = receiver;
        if (!controller) {
            return;
        }
        const { conference } = state['features/base/conference'];
        if (!dontNotifyRemoteParty) {
            sendSignatureEndpointMessage(conference, controller, {
                type: EVENTS.stop
            });
        }
        dispatch({
            type: SET_SIGNATURE_CONTROLLER,
            controller: undefined
        });
        transport.sendEvent({
            name: SIGNATURE_MESSAGE_NAME,
            type: EVENTS.stop
        });
        dispatch(setSiganatureActive(false));
        if (!dontNotifyLocalParty) {
            dispatch(showNotification({
                descriptionKey: 'dialog.remoteControlStopMessage',
                titleKey: 'dialog.remoteControlTitle'
            }, NOTIFICATION_TIMEOUT_TYPE.LONG));
        }
    };
}
